'use strict';
(function () {
    App.factory('lifeInsuranceService', lifeInsuranceServiceFactory);

    lifeInsuranceServiceFactory.$inject = ['$q', 'baseService', 'Config'];

    function lifeInsuranceServiceFactory($q, baseService, Config) {

        function LifeInsuranceService() {
            this.saveDeclarations = function saveDeclarations(declarations) {
                var json = angular.toJson(declarations);

                console.log('saveDeclarations', json);

                return baseService.post(Config.API_URL + '/lifeInsuranceDeclaration/save', json);
            };

            this.getDeclarations = function getDeclarations() {
                return baseService.post(Config.API_URL + '/lifeInsuranceDeclaration/list', angular.toJson({pageNumber:0,pageSize:1000}));
            };

            this.getGroupedDeclarations = function getDeclarations(status) {
                status = status || "ALL";
                return baseService.post(Config.API_URL + '/lifeInsuranceDeclaration/grouped', angular.toJson({status: status}));
            };

            this.getAllDeclarationsFile = function() {
                return baseService.download(Config.API_URL + '/lifeInsuranceDeclaration/allDeclarations').then(function(success) {
                    return success;
                }, function(error) {
                    return error;
                });
            };

            this.getDeclarationsSelectedFile = function(data) {
                return baseService.download(Config.API_URL + '/lifeInsuranceDeclaration/declaration/selected', data).then(function(success) {
                    return success;
                }, function(error) {
                    return error;
                });
            };
            

            this.getDeclarationFile = function(uuid) {
                return baseService.download(Config.API_URL + '/lifeInsuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                    return success;
                }, function(error) {
                    return error;
                });
            };


            this.hasDeclarationByTypeAndIdentifier = function findByIdentifier(type, identifier) {
                var json = angular.toJson({
                    "identifier": identifier,
                    "type": type
                });

                return baseService.post(Config.API_URL + '/lifeInsuranceDeclaration/givenIdentifierHasDeclarationOfLifeInsuranceType', json);
            };
        }

        return new LifeInsuranceService();
    }
})();

